import React, { Component } from "react";
import TextField from "@material-ui/core/TextField";
import { connect } from "react-redux";
import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";
import { withStyles } from "@material-ui/core/styles";
import styled from "styled-components";
import { bindActionCreators } from "redux";
import ActionCreators from "../store/actions";
import background from "../images/vehiclesParked.jpg";
import ForgotPasswordDialog from "../Components/ForgotPassword/ForgotPasswordDialog";

const styles = theme => ({
	container: {
		width: "50%",
		display: "flex",
		flexDirection: "column",
		justifyContent: "center",
		alignItems: "center",
		marginBottom: theme.spacing(10)
	},
	textField: {
		margin: theme.spacing(1),
		width: 450
	},
	button: {
		margin: theme.spacing(1),
		marginTop: theme.spacing(2),
		width: 200,
		color: "#FFF"
	},
	image: {
		width: "50%",
		backgroundImage: `url(${background})`,
		backgroundRepeat: "no-repeat",
		backgroundSize: "cover",
		backgroundPosition: "left top"
	},
	header: {
		marginBottom: theme.spacing(5),
	},
	headerText: {
		textAlign: "center",
		margin: theme.spacing(3)
	},
	form: {
		display: "flex",
		flex: "wrap",
		flexDirection: "column",
		justifyContent: "center"
	},
	accountProps: {
		display: "flex",
		alignItems: "center",
		justifyContent: "space-between",
		margin: theme.spacing(1)
	},
	checkbox: {
		color: "#808495",
	},
	footer: {
		position: "absolute",
		bottom: 10
	},
	forgotPassword: {
		alignSelf: "flex-end",
		margin: theme.spacing(1),
		cursor: "pointer"
	}
});

const AuthWrapper = styled.div`
    display: flex;
    height: 100vh;
    width: 100%;
    margin: 0;
`;

export class AuthView extends Component {
	state = {
		username: "",
		password: "",
		email: "",
		forgotPasswordOpen: false
	};

	onUserNameChangeHandler = event => {
		this.setState({ username: event.target.value });
	};

	onEmailChangeHandler = event => {
		this.setState({ email: event.target.value });
	};

	onPasswordChangeHandler = event => {
		this.setState({ password: event.target.value });
	};

	onClickHandler = () => {
		this.props.auth(this.state.email, this.state.username, this.state.password);
	};

	onKeyUpHandler = event => {
		if (event.key === "Enter") {
			this.props.auth(
				this.state.email,
				this.state.username,
				this.state.password
			);
		}
	};

	handleOpenForgotPasswordDialog = () => {
		this.setState({forgotPasswordOpen: true});
	};

	handleForgotPassword = (state) => {
		this.props.forgotPassword(state.username, state.login, state.email);
	};

	render() {
		let { classes, error } = this.props;
		let { email, username, password } = this.state;

		return (
			<AuthWrapper>
				<div className={classes.container}>
					<section>
						<div className={classes.header}>
							<h2
								variant="h2"
								className={classes.headerText}
							>
								Qsafe24 RENT MANAGEMENT
              				</h2>
							<p
								variant="subtitle2"
								className={classes.headerText}
							>
								LOGOWANIE OPERATORA
              				</p>
						</div>
						<form className={classes.form} onKeyUp={this.onKeyUpHandler}>
							<TextField
								classes={{ root: classes.textField }}
								id="username"
								label="Użytkownik"
								type="email"
								name="email"
								value={email}
								color="secondary"
								InputLabelProps={{ style: { color: "#32387D" } }}
								onChange={this.onEmailChangeHandler}
							/>
							<TextField
								classes={{ root: classes.textField }}
								id="login"
								label="Login"
								type="text"
								name="username"
								value={username}
								color="secondary"
								InputLabelProps={{ style: { color: "#32387D" } }}
								onChange={this.onUserNameChangeHandler}
							/>
							<TextField
								className={classes.textField}
								id="password"
								label="Hasło"
								type="password"
								name="password"
								error={error}
								value={password}
								color="secondary"
								InputLabelProps={{ style: { color: "#32387D" } }}
								onChange={this.onPasswordChangeHandler}
							/>
							<Typography
								variant="body1"
								className={classes.forgotPassword}
								onClick={this.handleOpenForgotPasswordDialog}
							>
								Nie pamiętam hasła
							</Typography>
							<Button
								className={classes.button}
								color="secondary"
								variant="contained"
								onClick={this.onClickHandler}
							>
								Zaloguj
              				</Button>
						</form>
					</section>
					<div className={classes.footer}>
						<p variant="body1">
							Copyrights © 2020:  ETS Polska
            			</p>
					</div>
					<ForgotPasswordDialog
						open={this.state.forgotPasswordOpen}
						onClose={() => this.setState({forgotPasswordOpen: false})}
						onSubmit={this.handleForgotPassword}
					/>
				</div>
				<div className={classes.image} />
			</AuthWrapper>
		);
	}
}

const mapDispatchToProps = dispatch => {
	return bindActionCreators(ActionCreators, dispatch);
};

const mapStateToProps = state => {
	return {
		error: state.authReducer.authError
	};
};

export default withStyles(styles)(
	connect(
		mapStateToProps,
		mapDispatchToProps
	)(AuthView)
);
